import { api } from '@/lib/axios';
import {
  VenueReservation,
  CreateReservationDto,
  UpdateReservationDto,
  AddGuestsDto,
  UpdateGuestDto,
  GetReservationsQueryDto,
  PaginatedReservations,
} from '@caruso/types';

export const venueReservationsService = {
  async getAll(
    query: GetReservationsQueryDto,
  ): Promise<PaginatedReservations> {
    const response = await api.get<PaginatedReservations>(
      '/venue-reservations',
      { params: query },
    );
    return response.data;
  },

  async getById(id: string): Promise<VenueReservation> {
    const response = await api.get<VenueReservation>(
      `/venue-reservations/${id}`,
    );
    return response.data;
  },

  async create(data: CreateReservationDto): Promise<VenueReservation> {
    const response = await api.post<VenueReservation>(
      '/venue-reservations',
      data,
    );
    return response.data;
  },

  async update(
    id: string,
    data: UpdateReservationDto,
  ): Promise<VenueReservation> {
    const response = await api.patch<VenueReservation>(
      `/venue-reservations/${id}`,
      data,
    );
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/venue-reservations/${id}`);
  },

  async addGuests(id: string, data: AddGuestsDto): Promise<void> {
    await api.post(`/venue-reservations/${id}/guests`, data);
  },

  async updateGuest(
    reservationId: string,
    guestId: string,
    data: UpdateGuestDto,
  ): Promise<void> {
    await api.patch(
      `/venue-reservations/${reservationId}/guests/${guestId}`,
      data,
    );
  },

  async removeGuest(reservationId: string, guestId: string): Promise<void> {
    await api.delete(
      `/venue-reservations/${reservationId}/guests/${guestId}`,
    );
  },

  async getCalendar(
    venueId?: string,
    startDate?: string,
    endDate?: string,
  ): Promise<VenueReservation[]> {
    const response = await api.get<VenueReservation[]>(
      '/venue-reservations/calendar',
      {
        params: { venueId, startDate, endDate },
      },
    );
    return response.data;
  },
};
